import axios from 'axios';
import { authHeaders } from './authHeaders';
import { AuditLogResponse, FilterOptionsResponse, LogsQueryParams } from '../types/AuditLog';

const API_URL = '/api/audit';

/**
 * Servicio para consumir la API de auditoría
 */
const auditService = {
  /**
   * Obtiene logs paginados con filtros
   */
  async getLogs(params: LogsQueryParams = {}): Promise<AuditLogResponse> {
    try {
      const queryParams = new URLSearchParams();

      if (params.page) queryParams.append('page', params.page.toString());
      if (params.limit) queryParams.append('limit', params.limit.toString());
      if (params.usuario) queryParams.append('usuario', params.usuario);
      if (params.resultado) queryParams.append('resultado', params.resultado);
      if (params.tipoDocumento) queryParams.append('tipoDocumento', params.tipoDocumento);
      if (params.numeroDocumento) queryParams.append('numeroDocumento', params.numeroDocumento);
      if (params.fechaInicio) queryParams.append('fechaInicio', params.fechaInicio);
      if (params.fechaFin) queryParams.append('fechaFin', params.fechaFin);

      const url = `${API_URL}/logs${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;

      const response = await axios.get(url, {
        headers: authHeaders()
      });

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as AuditLogResponse;
      }
      return {
        success: false,
        data: [],
        pagination: { page: 1, limit: 50, total: 0, totalPages: 0 },
        error: error instanceof Error ? error.message : 'Error desconocido'
      };
    }
  },

  /**
   * Obtiene las opciones de filtros disponibles
   */
  async getFilterOptions(): Promise<FilterOptionsResponse> {
    try {
      const response = await axios.get(`${API_URL}/filters`, {
        headers: authHeaders()
      });

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as FilterOptionsResponse;
      }
      return {
        success: false,
        data: { usuarios: [], tiposDocumento: [], resultados: [] },
        error: error instanceof Error ? error.message : 'Error desconocido'
      };
    }
  }
};

export default auditService;
